import Loader from "react-loaders"
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters"
import { useEffect, useState } from "react"
import "./tips.scss"
import { Link } from "react-router-dom"
import JsLogo from "../../assets/images/JavaScript-logo.png"
import ReactLogo from "../../assets/images/react-logo.png"
import NodeJsLogo from "../../assets/images/nodeJs-logo.png"

function Tips() {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container tips-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={["P", "r", "o", "g", "r", "a", "m", "i", "n", "g", " ", "T", "i", "p", "s"]}
                            idx={15}
                        />
                    </h1>
                </div>
                <div className="tips-container">
                    {/* <div className="tip-content">
                        <Link to="/jsTips">
                            <img src={JsLogo} alt="Javascript-Logo" />
                        </Link>
                    </div> */}
                    <div className="tip-content">
                        <Link to="/reactTips">
                            <img src={ReactLogo} alt="React-Logo" />
                        </Link>
                    </div>
                    <div className="tip-content">
                        <Link to="/nodeJsTips">
                            <img src={NodeJsLogo} alt="NodeJs-Logo" />
                        </Link>
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default Tips